/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV0NodeitemMoveNodeItemsPost$Params {
  newParent?: string;
      body?: Array<string>
}

export function apiV0NodeitemMoveNodeItemsPost(http: HttpClient, rootUrl: string, params?: ApiV0NodeitemMoveNodeItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0NodeitemMoveNodeItemsPost.PATH, 'post');
  if (params) {
    rb.query('newParent', params.newParent, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0NodeitemMoveNodeItemsPost.PATH = '/api/v0/nodeitem/moveNodeItems';
